// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/index.scss
// module id = 2
// module chunks = 0